import { render } from "./MBDatatableWithDisabled.vue?vue&type=template&id=facd189c&ts=true"
import script from "./MBDatatableWithDisabled.vue?vue&type=script&lang=ts"
export * from "./MBDatatableWithDisabled.vue?vue&type=script&lang=ts"

import "./MBDatatableWithDisabled.vue?vue&type=style&index=0&id=facd189c&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__